import React, {useCallback} from 'react';
import {useTranslation} from 'react-i18next';
import EditorLayout from '../../../../components/Layouts/EditorLayout';
import {PortalSettingsGetSchema} from '../../../../api/DBSchema/PortalSettings';
import SMCLabel from '../../../../components/Simple/SMCLabel';
import CustomFieldsTable from './PortalSettingsCustomFields/CustomFieldsTable';
import Sepperator from '../../../../components/Simple/Sepperator';

const pageSchema = PortalSettingsGetSchema.pages.customFields;
const pageId = pageSchema.pageId;

function PortalSettingsCustomFields({
    portalSettingsObject,
    setPortalSettingsData
}) {
    const { t } = useTranslation();

    const pageData = portalSettingsObject[pageId];
    const setPageValue = useCallback((paramName, value) => {
        setPortalSettingsData([pageId, paramName], value);
    }, [setPortalSettingsData]);

    
    const userCustomFields      = pageData[pageSchema.userCustomFields];
    const gatewayCustomFields   = pageData[pageSchema.gatewayCustomFields];
    const communityCustomFields = pageData[pageSchema.communityCustomFields];

    return (
        <EditorLayout>
            {/* User custom fields */}
            <SMCLabel
                bold
                style={{ fontSize: '15px' }}
                tooltip={<>
                    {t('SMP.SETTINGS.CUSTOM_FIELDS.USER_CUSTOM_FIELDS.TOOLTIP.LINE1')}&nbsp;
                    <b>{t('SMP.SETTINGS.CUSTOM_FIELDS.USER_CUSTOM_FIELDS.TOOLTIP.LINE2')}</b>&nbsp;
                    {t('SMP.SETTINGS.CUSTOM_FIELDS.USER_CUSTOM_FIELDS.TOOLTIP.LINE3')}&nbsp;
                    <b>{t('SMP.SETTINGS.CUSTOM_FIELDS.USER_CUSTOM_FIELDS.TOOLTIP.LINE4')}</b>&nbsp;
                    {t('SMP.SETTINGS.CUSTOM_FIELDS.USER_CUSTOM_FIELDS.TOOLTIP.LINE5')}&nbsp;
                    <b>{t('SMP.SETTINGS.CUSTOM_FIELDS.USER_CUSTOM_FIELDS.TOOLTIP.LINE6')}</b>&nbsp;
                    {t('SMP.SETTINGS.CUSTOM_FIELDS.USER_CUSTOM_FIELDS.TOOLTIP.LINE7')}
                </>}
            >
                {t('SMP.SETTINGS.CUSTOM_FIELDS.USER_CUSTOM_FIELDS')}
            </SMCLabel>
            <SMCLabel bold>{t('SMP.SETTINGS.CUSTOM_FIELDS.USER_CUSTOM_FIELDS.LINE8')}</SMCLabel>
            <CustomFieldsTable
                customFieldsList={userCustomFields}
                setCustomFieldsList={val => setPageValue(pageSchema.userCustomFields, val)}
            />
            <Sepperator />
            {/* Gateway custom fields */}
            <SMCLabel
                bold
                style={{ fontSize: '15px' }}
                tooltip={<>
                    {t('SMP.SETTINGS.CUSTOM_FIELDS.GW_CUSTOM_FIELDS.TOOLTIP.LINE1')}&nbsp;
                    <b>{t('SMP.SETTINGS.CUSTOM_FIELDS.GW_CUSTOM_FIELDS.TOOLTIP.LINE2')}</b>&nbsp;
                    {t('SMP.SETTINGS.CUSTOM_FIELDS.GW_CUSTOM_FIELDS.TOOLTIP.LINE3')}&nbsp;
                    <b>{t('SMP.SETTINGS.CUSTOM_FIELDS.GW_CUSTOM_FIELDS.TOOLTIP.LINE4')}</b>&nbsp;
                    {t('SMP.SETTINGS.CUSTOM_FIELDS.GW_CUSTOM_FIELDS.TOOLTIP.LINE5')}&nbsp;
                    <b>{t('SMP.SETTINGS.CUSTOM_FIELDS.GW_CUSTOM_FIELDS.TOOLTIP.LINE6')}</b>&nbsp;
                    {t('SMP.SETTINGS.CUSTOM_FIELDS.GW_CUSTOM_FIELDS.TOOLTIP.LINE7')}
                </>}
            >
                {t('SMP.SETTINGS.CUSTOM_FIELDS.GW_CUSTOM_FIELDS')}
            </SMCLabel>
            <SMCLabel bold>{t('SMP.SETTINGS.CUSTOM_FIELDS.GW_CUSTOM_FIELDS.TOOLTIP.LINE8')}</SMCLabel>
            <CustomFieldsTable
                customFieldsList={gatewayCustomFields}
                setCustomFieldsList={val => setPageValue(pageSchema.gatewayCustomFields, val)}
            />
            <Sepperator />
            {/* Community custom fields */}
            <SMCLabel
                bold
                style={{ fontSize: '15px' }}
                tooltip={t('SMP.SETTINGS.CUSTOM_FIELDS.COMMUNITY_CUSTOM_FIELDS.TOOLTIP')}
            >
                {t('SMP.SETTINGS.CUSTOM_FIELDS.COMMUNITY_CUSTOM_FIELDS')}
            </SMCLabel>
            <SMCLabel bold>{t('SMP.SETTINGS.CUSTOM_FIELDS.COMMUNITY_CUSTOM_FIELDS.LINE1')}</SMCLabel>
            <CustomFieldsTable
                customFieldsList={communityCustomFields}
                setCustomFieldsList={val => setPageValue(pageSchema.communityCustomFields, val)}
            />
        </EditorLayout>
    )
}

export default PortalSettingsCustomFields;